export class ToCountBaseValueConverter {
    toView(value) {
        if (value >= 0) {
            return value;
        }
        return '-';
    }
}